import type { SVGMotionProps, Transition } from 'motion/react'
import { motion } from 'motion/react'

const transition: Transition = {
  duration: 0.8,
  type: 'spring',
  bounce: 0.5,
}

export const Bars = ({
  isHovered,
  ...props
}: SVGMotionProps<SVGSVGElement> & { isHovered?: boolean }) => {
  return (
    <motion.svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      animate={isHovered ? 'hover' : undefined}
      whileHover="hover"
      {...props}
    >
      <motion.rect
        transition={transition}
        initial={{ y: 0 }}
        variants={{ hover: { height: 3, y: 9 - 3 } }}
        width={4.481}
        height={9}
        x={3.332}
        y={7.563}
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={1.3}
        fill="none"
      />
      <motion.rect
        transition={transition}
        initial={{ y: 0 }}
        variants={{ hover: { height: 6, y: 13 - 6 } }}
        width={4.481}
        height={13}
        x={7.813}
        y={3.563}
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={1.3}
        fill="none"
      />
      <motion.rect
        transition={transition}
        initial={{ y: 0 }}
        variants={{ hover: { height: 13, y: 5 - 13 } }}
        width={4.481}
        height={5}
        x={12.293}
        y={11.562}
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={1.3}
        fill="none"
      />
      <motion.line
        x1={1.837}
        x2={18.163}
        y1={16.572}
        y2={16.572}
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.3}
        fill="none"
      />
    </motion.svg>
  )
}
